export default function converteDataUS(data) {
  if (!data || data === "") return null;

  if (typeof data === "string" && data.includes("-") && data.length === 10) {
    return data;
  }

  if (
    typeof data === "object" &&
    (data instanceof Date || data.$d || data.toDate)
  ) {
    let dateObj;

    if (data.toDate && typeof data.toDate === "function") {
      dateObj = data.toDate();
    } else if (data.$d) {
      dateObj = data.$d;
    } else {
      dateObj = data;
    }

    const ano = dateObj.getFullYear();
    const mes = String(dateObj.getMonth() + 1).padStart(2, "0");
    const dia = String(dateObj.getDate()).padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
  }

  if (typeof data === "string" && data.includes("/")) {
    const data_conv = `${data.slice(6, 10)}-${data.slice(3, 5)}-${data.slice(
      0,
      2
    )}`;
    return data_conv;
  }

  return data;
}
